// ProfessionaltNotes.jsx

// Components
import TextEditor from '@/components/data/common/text/TextEditorNotesHomepage';

// Services
import { updateProfessionalNotes, deleteProfessionalNotes } from '@/services/schedulingService';

const ProfessionalNotes = ({ professionalID, professionalNotes, onUpdate }) => {
  async function deleteNotes() {
    await deleteProfessionalNotes(professionalID);
    if (onUpdate) onUpdate('');
  }

  async function updateNotes(notes) {
    await updateProfessionalNotes(professionalID, notes);
    if (onUpdate) onUpdate(notes);
  }

  return <TextEditor value={professionalNotes} updateText={updateNotes} deleteText={deleteNotes}></TextEditor>;
};

export default ProfessionalNotes;
